//#region IMPORTS
import { clearOrderParams } from "../../features/orders/ordersSlice";
import { useAppDispatch, useAppSelector } from "../../store/configureStore";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import HomeInfoItemsExcelDownload from "./HomeInfoItemsExcelDownload";
import useActiveWeekInstoreTemplateForStore from "../../hooks/useActiveWeekInstoreTemplateForStore";
import useBasketGate from "../../hooks/useBasketGate";
import useWeekDay from "../../hooks/useWeekDay";
import classNames from "../../helpers/classNames";
//#endregion

//#region INTERFACE
interface Props {
  isPicker: boolean;
  isAdmin: boolean;
  HQTeam: boolean;
}
//#endregion

export default function HomeInfoItems({ isAdmin, isPicker, HQTeam }: Props) {
  //#region SETUP
  // Translation
  const { t } = useTranslation();

  // Router
  const history = useHistory();

  // Redux
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.account);

  // Block the week order when a promo basket is active (mutually exclusive)
  const { guardInstoreAction } = useBasketGate();

  // Dates
  const current = new Date();
  const weekday = useWeekDay(current);

  // The active "Week" template available for this shop's own store format.
  const shopWeekTemplate = useActiveWeekInstoreTemplateForStore(
    user?.store?.store_format_id,
  );
  const showShopWeekButton =
    !isAdmin && !HQTeam && !isPicker && !!shopWeekTemplate;
  //#endregion

  //#region RENDER
  return (
    <div className="text-white text-center text-lg font-semibold mb-8 mt-4 lg:[grid-area:odg] lg:mb-0 lg:mt-0">
      <div className="grid grid-cols-1 auto-rows-fr gap-4 h-full">
        {isAdmin || HQTeam || isPicker ? (
          <button
            className="text-white rounded-lg bg-sky-900 flex items-center font-semibold justify-center p-4 hover:bg-sky-800"
            onClick={() => {
              history.push("/orders?tab=instore");
            }}
          >
            {t("rituals.instoreOrders")}
          </button>
        ) : showShopWeekButton ? (
          <button
            className="text-white rounded-lg bg-sky-900 flex items-center font-semibold justify-center p-4 hover:bg-sky-800"
            onClick={guardInstoreAction(() =>
              history.push(`/promos/instore/${shopWeekTemplate.id}`)
            )}
          >
            New week order
          </button>
        ) : null}

        <div
          className={classNames(
            !(isAdmin || HQTeam || isPicker || showShopWeekButton)
              ? "row-span-2"
              : "",
            "rounded-lg bg-amber-500 flex items-center font-semibold justify-center p-4"
          )}
        >
          {isAdmin ? (
            <HomeInfoItemsExcelDownload />
          ) : (
            <div>
              <p>{t(`rituals.${weekday.toString()}`)}</p>
              <p>{`${current.getDate()}/${
                current.getMonth() + 1
              }/${current.getFullYear()}`}</p>
            </div>
          )}
        </div>

        <button
          className="text-white rounded-lg bg-teal-900 hover:bg-teal-800 flex items-center justify-center p-4 font-semibold"
          onClick={() => {
            dispatch(clearOrderParams());
            history.push("/orders");
          }}
        >
          {t("rituals.orderHistory")}
        </button>
      </div>
    </div>
  );
  //#endregion
}
